import LAYOUT_CONST from 'constant';

export const DASHBOARD_PATH = 'dashboard';
export const EMPLOYER_ROLE = 'employer';
export const EMPLOYEE_ROLE = 'employee';
export const ADMIN_ROLE = 'admin';
export const CS_TECHNICAL_ROLE = 'cs-technical';
export const CS_OTHERS_ROLE = 'cs-others';
export const CA_USER = 'ca';

export const HORIZONTAL_MAX_ITEM = 7;
// import '../src/assets/css/app.css'

const config = {
    layout: LAYOUT_CONST.HORIZONTAL_LAYOUT, // vertical, horizontal
    drawerType: LAYOUT_CONST.DEFAULT_DRAWER, // default, mini-drawer
    fontFamily: `'GilroyLight', sans-serif`,
    borderRadius: 20,
    outlinedFilled: true,
    navType: 'light', // light, dark
    locale: 'en', // 'en' - English, 'fr' - French, 'ro' - Romanian, 'zh' - Chinese
    container: false
};

export default config;
